module.exports = __webpack_public_path__ + "4f589f4867dbd57elist-1.c00c92c6.png";